module.exports = __webpack_public_path__ + "img/19.303f25ed.svg";